import React, { Component } from 'react';
import { Form } from 'react-final-form';
import { FORM_ERROR } from 'final-form';
import Bluebird from 'bluebird';
import { Paper, Grid, Button, Typography } from '@mui/material';
import snackbarHelper from '../helpers/snackbarHelper';
import * as errorsHelper from '../helpers/errors';
import { ATTACH_SITE_RADIUS_IN_MILES } from '../models/systemSettings';
import RFFTextField from './Common/RFFTextField';

class SystemSettingsForm extends Component {
  handleSubmit = updateSettings => values => Bluebird
    .try(() => updateSettings(values))
    .then(() => snackbarHelper.success('System settings updated successfully!'))
    .catch(err => {
      errorsHelper.handleError(err);

      return { [FORM_ERROR]: 'error' };
    });

  render() {
    const { systemSettings, onSubmit } = this.props;
    let initialValues = {};

    systemSettings.map(systemSetting => initialValues[systemSetting.name] = systemSetting.value);

    return (
      <Form
        onSubmit={this.handleSubmit(onSubmit)}
        initialValues={initialValues}
        render={({ handleSubmit, submitting, pristine, invalid }) => (
          <form onSubmit={handleSubmit}>
            <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={0}>
              <Grid item xs={12}>
                <Paper sx={{ display: 'flex', flexDirection: 'column', padding: { xs: 1, sm: 2 } }}>
                  <Typography color="textPrimary" variant="h6">
                    System Settings
                  </Typography>

                  <RFFTextField
                    name={ATTACH_SITE_RADIUS_IN_MILES}
                    type="number"
                    label="Attach site radius in miles"
                    style={{ width: 300, marginBottom: '10px' }}
                    variant="standard"
                  />

                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={pristine || invalid || submitting}
                    sx={{ marginTop: 1, width: 300 }}
                  >
                    Update System Settings
                  </Button>
                </Paper>
              </Grid>
            </Grid>
          </form>
        )}
      />
    );
  }
}

export default SystemSettingsForm;
